//----- Responsive Navigation ----- 
//At the time of building the template foundation had a nasty bug where you couldn't access the the accordion, drilldown or dropdown method's making very difficult to programmatically trigger lists or catch events, so this " module " had to be wrote instead of using foundations own responsive navigation plugin.

// The functionality inside of this module is also being used for the filters for restoring the users position after AJAX.

// Had to switch the the header navigation to using this module due to this bug https://github.com/foundation/foundation-sites/issues/11611 even though the " fix " has been merged in to the current version installed 6.6.1 it has made no difference.


var instances = {};

// Responsive menu initialise.
function initaliseAllResponseMenus() {
    $('[data-axis-responsive-menu]').each(function() {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "Responsive Menu: Initialising all responsive menu's");
        }
        // Store context.
        let context = $(this);
        // Initialise menu.
        let menu = responseMenuInitialise(context);

        if (!menu) {
            AXISDebug.output(3, "Response Menu: Failed to intialise.");
        } 
    });
}

function responseMenuInitialise(context, ajax) {
    var id = context.attr('id');
    // Gets used to store initialised menu.
    let menu;
    // Make sure menu has an id.
    if (id == undefined || id == "") {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Responsive: No Id on the menu generating one");
        }
        id = "menu-" + generateId();
        context.attr('id', id);
    }

    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1, "Responsive Menu: Attempting to initialise: " + id);
    }

    instances[id] = {};
    instances[id]['ajax'] = ajax;
    // Add context to instance obj.
    setContext(id, context);
    // Is this a mega menu?
    let isMegaMenu = (context.attr(expressSelectors()['mega-menu']['initialise']) != undefined);
    // Get responsive mapping ( what to do if mobile or desktop ).
    let responsiveMapping;
    if (isMegaMenu) {
        responsiveMapping = context.find('[data-axis-responsive-menu]');
        if (responsiveMapping) {
            responsiveMapping = responsiveMapping.attr('data-axis-responsive-menu');
        } else {
            AXISDebug.output(3,"Responsive Menu: Could not find responsive mapping for mega menu", context);
            return false;
        }
    } else {
        responsiveMapping = context.data('axis-responsive-menu');
    }
    //Split the responsive mapping data value into an array.
    responsiveMapping = responsiveMapping.split(" ");
    // Add responsive mapping to config.
    setResponsiveMapping(id, responsiveMapping);
    //If no responsive mapping defined then skip over this menu ( likely a nested / submenu ).
    if (responsiveMapping != undefined && id) {
        //Determine which menu type to display, then initialise it.
        menu = determineMenuBreakpoint(id);
    } else {
        AXISDebug.output(3,"Responsive Menu: Could not determine responsive mapping.");
    }

    // Trigger any menus.
    let openOnload = context.find('[data-open-onload]');
    if (openOnload.length) {
        openOnload.each(function() {
            // Context.
            let onloadMenu = $(this);
            // Trigger Menu.
            if (context.hasClass('drilldown-menu')) {
                context.foundation('_showMenu', onloadMenu);
            } else if (context.hasClass('accordion-menu')) {
                context.foundation('down', onloadMenu);
            } else {
                AXISDebug.output(2,"Responsive Menu: We dont current support opening that menu type using the data-open-onload attribute", onloadMenu);
            }
        });
    }

    if (!id) {
        AXISDebug.output(2, "Responsive Menu: Skipping menu as Menu Id is undefined.");
        return false;
    } else {
        return id;
    }


    
}

function setResponsiveMapping(id, value) {
    instances[id]['responsive-mapping'] = value;
    return instances[id]['responsive-mapping'];
}

function getResponsiveMapping(id) {
    return instances[id]['responsive-mapping'];
}

function setMenu(id, menu) {
    instances[id]['menu'] = menu;
    return instances[id]['menu'];
}

function getMenu(id) {
    return instances[id]['menu'];
}

function setMenuType(id, type) {
    instances[id]['type'] = type;
    return instances[id]['type'];
}

function getMenuType(id) {
    return instances[id]['type'];
}

function setContext(id, context) {
    instances[id]['context'] = context;
    return instances[id]['context'];
}

function getContext(id) {
    return instances[id]['context'];
}

function setFoundationMenu(id, value) {
    return instances[id]['is-foundation-menu'] = value;
}

function getFoundationMenu(id) {
    return instances[id]['is-foundation-menu'];
}

//Determine whether to display the mobile mapping or desktop.
function determineMenuBreakpoint(id) {
    // Get responsive mapping from instances obj.
    let mapping = getResponsiveMapping(id);
    //Determine which responsive mapping value to initialise.
    if (currentBreakpoint() < 3 || mapping[1] == undefined) {
        if (mapping[1] == undefined) {
            AXISDebug.output(2, "Responsive Menu: No desktop menu type defined defaulting to mobile type which is: " + mapping[0]);
        }
        //Take the mobile mapping and pass it the menu initialise.
        return menuInitialise(id, mapping[0]);
    } else if (currentBreakpoint() >= 3 && mapping[1] != undefined) {
        //Take the desktop mapping and pass it the menu initialise.
        return menuInitialise(id, mapping[1]);
    } else {
        AXISDebug.output(3, "Responsive Menu: could no determine menu type.");
        return false;
    }
}

// Once we have determined whether to output the mobile or desktop mapping go to the actually menu initialise.
function menuInitialise(id, type) {
    // Hold the menu after initialised.
    let menu = null;
    // Get content so we can assign appropriate type class.
    let context = getContext(id);
    // Apply transition's when opening / closing.
    let enableTransitions = context.attr('data-enable-transitions');
    // Default to true if not defined.
    enableTransitions = (enableTransitions == 'false' ? false : true);
    // Use menuType to initialise specific menu.
    switch (type) {
        case "dropdown":
            if (AXISDebug.level() >= 2) {
                AXISDebug.output(1, "Responsive Menu: Initialising Dropdown menu for: " + id);
            }
            // Add menu type class.
            context.addClass(type);
            // Initialise menu.
            menu = new Foundation.DropdownMenu(context);
            // Set Menu Type.
            setMenuType(id, type);
            // Set foundation menu flag.
            setFoundationMenu(id, true);
            // Is this a megamenu.
            let megamenuContext = context.parents('[' + expressSelectors()['mega-menu']['initialise'] + ']');
            // If this is a mega menu dropdown.
            if (megamenuContext.length) {
                
            }
            break;
        case "accordion":
            if (AXISDebug.level() >= 2) {
                AXISDebug.output(1, "Responsive Menu: Initialising Accordion menu for: " + id);
            }
            // Add menu type class.
            context.addClass(type + "-menu");
            // Initialise menu.
            menu = new Foundation.AccordionMenu(context, {
                slideSpeed: (enableTransitions ? 500 : 0)
            });
            // Set Menu Type.
            setMenuType(id, type);
            // Set foundation menu flag.
            setFoundationMenu(id, true);
            break;
        case "drilldown":
            if (AXISDebug.level() >= 2) {
                AXISDebug.output(1, "Responsive Menu: Initialising Drilldown menu for: " + id);
            }
            // Add menu type class.
            context.addClass(type);
            // Initialise menu.
            menu = new Foundation.Drilldown(context);
            // Set Menu Type.
            setMenuType(id, type);
            // Set foundation menu flag.
            setFoundationMenu(id, true);
            break;
        case "list":
            // This menu type was specifically written for the footer to essentially output the entry menu in a list a form without any sort of revealling effects.
            // Add list style class to context.
            context.addClass('list-menu');
            // Find submenu's.
            let submenus = context.find('ul:not(:empty)');
            // Add submenu class.
            submenus.addClass('submenu');
            // Set Menu Type.
            setMenuType(id, type);
            // Set foundation menu flag.
            setFoundationMenu(id, false);
            // Pass back context.
            menu = context;
            break;
        case "mega-menu": 
            menu = AXISMegaMenu.initialise(context);
            // Set Menu Type.
            setMenuType(id, type);
            // Set foundation menu flag.
            setFoundationMenu(id, false);
            break;
        default:
            AXISDebug.output(3, "Responsive Menu: No type specified.");
    }

    if (menu != null) {
        // Add foundation menu to instances obj.
        setMenu(id, menu);
    }
    
    return menu;
}

//When you destroy a menu instance it leaves behind all of its classes and attributes ( thanks foundation ).
function menuCleanup(id) {
    // Get menu context.
    let context = getContext(id);
    // Get menu type.
    let type = getMenuType(id);
    // Clear up attributes, elements & classes for each menu type.
    switch (type) {
        case "dropdown":
            // Remove Classes.
            context.removeClass('dropdown');
            context.find('li').removeClass('is-dropdown-submenu-parent is-dropdown-submenu-item opens-right')
            context.find('ul').removeClass('is-dropdown-submenu');
            // Remove dropdown attribute.
            context.removeAttr('data-dropdown-menu');
            // Remove style attribute.
            context.find('ul').removeAttr('style');
            // Backwards compatibility before mega-menu became its own type.
            // Any megamenu classes / style.
            context.find('.mega-menu-column-span, .megamenu-column-cloned-span').removeAttr('style').removeClass('mega-menu-column-span megamenu-column-cloned-span');
            // Remove any cloned items.
            context.find('[data-mega-menu-cloned-item]').remove();
            break;
        case "accordion": 
            // Remove Classes.
            context.removeClass('accordion-menu');
            context.find('ul').removeClass('is-accordion-submenu');

            context.find('li').removeClass('is-accordion-submenu-item');
            context.find('li').removeClass('is-accordion-submenu-parent');

            context.find('li').removeAttr('aria-controls aria-expanded id');
            // Foundation leave's a click listener on anchor which still triggers after the accordion has been destroyed.
            context.find('a').off('click');

            // Remove accordion attribute.
            context.removeAttr('data-accordion-menu');
            // Remove style attribute.
            context.find('ul').removeAttr('style aria-labelledby aria-hidden id');
            break;
        case "drilldown": 
            //Remove parent class.
            context.removeClass('drilldown');
            //Remove back button.
            context.find('.js-drilldown-back').remove();
            // Remove drill down attribute.
            context.removeAttr('data-dropdown-menu');
            
            break;
        case "list": 
            // Remove parent class.
            context.removeClass('list-menu');
            break;
        case "mega-menu":
            break;
        default:
            AXISDebug.output(3, "Responsive Menu: Could not clean up menu due to either no type specified or could not find type: " + type);
            return false;
    }

    // If in mobile make sure container is not active ( i.e navigation, filters ).
    if (context.parents('nav, form').hasClass('active')) {
        context.parents('nav, form').removeClass('active');
    }

    return true;
}

var activeSubmenuObj = {};

function getActiveSubmenu(menuId) {
    if (menuId == undefined) {
      AXISDebug.output(3, "No menuId provided.");
      return false;
    }
    $('#' + menuId + " > li").each(function() {
      //Context.
      var submenu = $(this);  
      var submenuId = $(submenu).attr('id');
      if (submenu.attr('aria-expanded') == "true") {
        var menuProperties = "activeSubmenu-" + generateId();
        activeSubmenuObj[menuProperties] = {};
        //Capture the menuId.
        activeSubmenuObj[menuProperties]["submenuId"] = submenuId;
        //Capture the menu context.
        activeSubmenuObj[menuProperties]["submenuContext"] = submenu;
        //This is for attributes filters to capture whether the overflow is active.
        var isChildActive = $("#" + submenuId + " .showMoreAttributes").attr('aria-expanded');
        if (isChildActive != undefined) {
            activeSubmenuObj[menuProperties]["isChildActive"] = JSON.parse(isChildActive);
            // Get the scroll position for the active attribute.
            var menuScrollPosition = $("#" + submenuId + " > ul").scrollTop();
            // Save the scroll position so it can be applied again after AJAX post.
            activeSubmenuObj[menuProperties]["menuScrollPosition"] = menuScrollPosition;
        } else {
            activeSubmenuObj[menuProperties]["isChildActive"] = false;
        }

        storeActiveMenu(menuId, activeSubmenuObj);
      }
    });

    // Get the the scroll position and store it for when the callback replaces the content.
    activeSubmenuObj["lastPosition"] = getScrollPosition("filters");
    storeActiveMenu(menuId, activeSubmenuObj);

    if (AXISDebug.enabled()) {
        AXISDebug.output(1, "Captured active menu's:");
        console.table(activeSubmenuObj);
    }
    return true;
}

// General function for extracting the list's scroll position.
function getScrollPosition(menuId, exclusions) {
    let scrollPosition = 0;

    if ($('#' + menuId).parents('div, form, ul').hasClass('list-container')) {
        if (currentBreakpoint() <= 2) {
            // Mobile view.
            scrollPosition = $('#' + menuId).parents('.list-container').scrollTop();
        } else {
            // Desktop default to page scroll bar.
            scrollPosition = $(document).scrollTop();
        }
    } else {
        scrollPosition = $(document).scrollTop();
    }
    // Loop through any exclusion(s) so that we should deduct from the scroll position each exclusion's height so when the new content height is measured we then add on the excluded elements new height this is nessesary as we do not know the height of the new content being added which will result in the incorrect scroll position being stored.
    $(exclusions).each(function(key, value) {
        // Capture exclusion in a jQuery object.
        let exclusion = $(value);
        // If exclusion exists.
        if (exclusion.length > 0) {
            // console.log(value)
            // Get the height of the excluded element.
            let exclusionHeight = $(value).height();
            // Deduct height from scroll position.
            scrollPosition = (scrollPosition - exclusionHeight);
        }
    });

    return scrollPosition;
}

// Used for storing the lists scroll position in session storage.
function getListScrollPosition(menuId, exclusions) {
    if (!menuId) {
        AXISDebug.output(3,"You must provide a menu id.");
        return false;
    }
    // Get any session storage values and parse to json.
    let data = JSON.parse(sessionStorage.getItem(menuId));
    // Get the scroll position.
    let scrollPosition = getScrollPosition(menuId, exclusions);
    // Store it.
    if (scrollPosition) {
       data["lastPosition"] = scrollPosition;
       return storeActiveMenu(menuId, data);
    } else {
        AXISDebug.output(3,"Failed to capture previous scroll position.")
        return false;
    }
}

function setListScrollPosition(menuId) {
    // Get the session storage string.
    let data = JSON.parse(sessionStorage.getItem(menuId));
    return data["lastPosition"];
}



function storeActiveMenu(menuId, item) {
    // Used on the product listing pages to determine whether the store active filters are actually for the content on the page.
    var pageContext = location.search;
    // Add page context to the active menu object.
    item["pageContext"] = pageContext;
    // Remove old session storage key.
    var key = sessionStorage.getItem(menuId);
    if ((key != null) || (key != undefined)) {
        // If there is already a key assigned to sessionStorage then remove it.
        sessionStorage.removeItem(menuId)
        AXISDebug.output(1, "Removing " + menuId +" menu active list item session storage");
    }
    // Convert Object to string as session storage can only store strings.
    var itemListString = JSON.stringify(item);
    // Store item list string inside of session storage.
    sessionStorage.setItem(menuId, itemListString);

    if (sessionStorage.getItem(menuId)) {
        return true;
    } else {
        AXISDebug.output(3, "Failed to set session storage.");
        return false;
    }
}

// Gets store menu from session storage using the menu Id for the session storage key.
function getStoredActiveMenu(menuId) {
    var data = sessionStorage.getItem(menuId);
    // If key not valid then get out out.
    if ((data == null) || (data == undefined)) {
        return false;
    }
    // Convert data from session storage into JSON object.
    var itemListObj = JSON.parse(data);
    // Checks to make sure the stored active filters are actually for the content on the page.
    if (itemListObj["pageContext"] == location.search) {
        // Update the global variable used by setActiveSubmenu function.
        activeSubmenuObj = itemListObj;
        // Open sub menu's.
        if (setActiveSubmenu(menuId) == true) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

function getStoredLastPosition() {
    let data = sessionStorage.getItem("filters", "lastPosition");
    // JSON parse the filters session storage.
    data = JSON.parse(data);
    // Get only the last position.
    data = data.lastPosition;
    return data;
}


function setActiveSubmenu(menuId) {
    // Updates the correct content list as the old list will be removed after AJAX content update complete.
    let contentContainer = ".contentContainer";
    // Menu Context.
    let parentMenu = $('#' + menuId);
    //Loop through active submenu object.
    $.each(activeSubmenuObj, function(key, value) {
        // Submenu context.
        let submenu = $(contentContainer + ' #' + value.submenuId + " > ul");
        //Open submenu.
        //$("#" + menuId).foundation('down', $(contentContainer + ' #' + value.submenuId + " > ul"));
        parentMenu.foundation('down', submenu);
        //Check if submenu child was active.
        if (value.isChildActive) {
            var childId = $(contentContainer + " #" + value.submenuId + " .showMoreAttributes > ul").attr('id');

            parentMenu.foundation('down', $('#' + childId));
            
            measureAttributeContainer(contentContainer + " #" + value.submenuId);
            // If the user had previously scroll down the attribute list, then restore their scroll position.
            if ($(value.menuScrollPosition).length) {

                setTimeout(() => {
                    $(contentContainer + ' #' + value.submenuId + " > ul").scrollTop(value.menuScrollPosition);
                }, 200);
                    
            }
        }
        //Remove the menu object from the list.
        delete activeSubmenuObj[key]; 
    });
    return true;
}

function measureAttributeContainer(listContext) {
    let filterDisplayLimit = 0;
    if (($('#filters').attr('data-attribute-display-limit') != undefined) && ($('#filters').attr('data-attribute-display-limit') != '')) {
    filterDisplayLimit = $('#filters').attr('data-attribute-display-limit');
    //Because jQuery will return a string.
    filterDisplayLimit = parseInt(filterDisplayLimit);

    if (AXISDebug.level() >= 4) {
        AXISDebug.output(1, "Responsive Menu: this menu can only display " + filterDisplayLimit + " items at a time");
    }

    } else {
        AXISDebug.output(2,"No attribute display limit set defaulting to 7");
        filterDisplayLimit = 7;
    }

    listContext = $(listContext);
    //console.log(listContext)
      //Count the filter attributes inside of the container that is in context.
      var filterCount = $(listContext).find('ul').children('li').length;
      //console.log("Filter count: " + filterCount);
      //Subtracting 2 to account for the show more / less <li>'s.
      filterCount = (parseInt(filterCount) - 2);
      //Incrementing the filter limit by 1 because the :lt selector is zero based.
      filterDisplayLimit = filterDisplayLimit + 1;

      if ((listContext.find('.menu-scroll-container').length == 0) && (currentBreakpoint() >= 3)) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "Responsive Menu: Breakpoint >= large device, checking whether number of attributes is higher than display limit");
        }

          if (filterCount > filterDisplayLimit) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "Responsive Menu: Display limit hit (" + filterDisplayLimit + ") enabling scroller for this submenu.");
            }

            //Trigger the scroll styling.
            listContext.children('ul').wrap('<div class="menu-scroll-container"></div>');

            // Store the height of the displayed filter attributes.
            let maxHeight = 0;

            // Attributes to display.
            let attributes = listContext.find('li:not(.showMoreAttributes)').slice(0, (filterDisplayLimit - 1))

            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "Responsive Menu: Here are the attribute that should be displaying: ", attributes);
            }
            

            //Count the inner height of the filters that we want to display.
            attributes.each(function () {
            let attribute = $(this);
                //If this is a container for a list then skip.
                if (attribute.hasClass('showMoreAttributesContainer')) {
                    return false;
                }

                maxHeight = maxHeight + attribute.outerHeight();
                //De-increment display limit counter.
                filterDisplayLimit--;
            
            });

            //Limit the amount of items being show.
            listContext.find('.menu-scroll-container').css('max-height', maxHeight);

          } 
      } else if (listContext.parent('.menu-scroll-container')) {
          //When clicking show less remove the scroller because only 5 filter attributes are shown.
          //listContext.removeClass('scroller');
          listContext.parent('.menu-scroll-container').unwrap();
      }
  }

var AXISResponsiveMenu = $.AXISResponsiveMenu = {
    initialise: (context, ajax) => {
        if (context) {
            return responseMenuInitialise(context, ajax);
        } else {
            return initaliseAllResponseMenus();
        }
        
    },
    resize: () => {
        $('[data-axis-responsive-menu]').each(function() {
            let context = $(this);
            // Get id for instance.
            let id = context.attr('id');
            if (id == undefined) {
                AXISDebug.output(3, "Responsive Menu: Cannot resize this menu due to not having an id, was this menu previously initialised? ", context);
                return false;
            }
            // Get the currently menu type.
            let currentType = getMenuType(id);
            // Get responsive mapping.
            let mapping = getResponsiveMapping(id);
            // Work out the resized type.
            let resizedType = (currentBreakpoint() >= 3 ? (mapping[1] ? mapping[1] : mapping[0]) : mapping[0]);
            // If menu type's match then skip re-initialation as its no required, css will do the heavy lifting here.
            // if (currentType == resizedType) {
            //     if (AXISDebug.level() >= 4) {
            //         AXISDebug.output(1, "Responsive Menu: skipping JS re-initialation due to resized type being the same a the current menu type.")
            //     }
            //     return false;
            // }
            let menu = getContext(id);
            // Check whether this is a foundation menu, if it is then destroy it.
            if (getFoundationMenu(id)) {
                let destroy = menu.foundation('_destroy');
            }
            // If mega-mega menu then destroy.
            if (currentType == "mega-menu") {
                let destroy = AXISMegaMenu.destroy(menu);
            }
            
            //Remove classes that are no longer needed.
            let cleanup = menuCleanup(id);
            // If clean up successful the re-initialise.
            if (cleanup) {
                menu = determineMenuBreakpoint(id);
            } else { 
                AXISDebug.output(3, "Responsive Menu: Cleanup failed cancelling initialisation of menu.");
                return false;
            }
        });
    },
    getActiveSubmenu: (menuId) => {
       return getActiveSubmenu(menuId);
    },
    setActiveSubmenu: (menuId) => {
        return setActiveSubmenu(menuId);
    },
    getStoredActiveSubmenu: (menuId) => {
        return getStoredActiveMenu(menuId);
    },
    getListScrollPosition: (menuId, exclusions) => {
        return getListScrollPosition(menuId, exclusions);
    },
    getStoredLastPosition: () => {
        return getStoredLastPosition();
    },
    setListScrollPosition: (menuId) => {
        return setListScrollPosition(menuId);
    },
    measureMenuItems: (listContext) => {
        return measureAttributeContainer(listContext);
    }
}

export { AXISResponsiveMenu };